import { createSelector } from 'reselect';

export const getOrderPunchCards = (state) => state.order.punchCards;

export const getOrderPunchCard = (orderId) =>
  createSelector([getOrderPunchCards], (punchCardsState) => punchCardsState.punchCards[orderId]);
